import {Container, Navbar, Col, Row} from 'react-bootstrap';


import Name from './Name';
import AboutMe from './AboutMe';
import More from './More';

const Home = () => {
    return (
        <>
            <Navbar bg="light" data-bs-theme="light">
                <Container>
                <Navbar.Brand href="#home" > <h5 className={'mod_card1'}><b>ANTHONER</b> MONZON'S PROFILE</h5></Navbar.Brand>
                </Container>
            </Navbar>
            <Row>
                <Col xs lg="3">
                    <Row>
                        <Col><br/><Name/></Col>
                    </Row>
                    <Row>
                        <Col><br/><AboutMe/></Col>
                    </Row>
                </Col>
                <Col xs lg="9">
                    <br/><More/>
                </Col>
            </Row>
        </>
    )
}

export default Home;
